import { render, staticRenderFns } from "./TiltakFilterDefault.vue?vue&type=template&id=67fdfcf9"
import script from "./TiltakFilterDefault.vue?vue&type=script&lang=js"
export * from "./TiltakFilterDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports